export const LOAD_LOW_BATT_REPORT = '[reports] load low battery report';
export const PROCESS_LOW_BATT_REPORT = '[reports] process low battery report';
export const INSERT_LOW_BATT_REPORT = '[reports] insert low battery report';
export const LOAD_DORMANT_DEVICES_REPORT =
  '[reports] load dormant devices report';
export const PROCESS_DORMANT_DEVICES_REPORT =
  '[reports] process dormant devices report';
export const INSERT_DORMANT_DEVICES_REPORT =
  '[reports] insert dormant devices report';
export const LOAD_MISSING_DEVICES_REPORT =
  '[reports] load missing devices report';
export const PROCESS_MISSING_DEVICES_REPORT =
  '[reports] process missing devices report';
export const INSERT_MISSING_DEVICES_REPORT =
  '[reports] insert missing devices report';
export const LOAD_ACTIVE_TAMPER_REPORT = '[reports] load active tamper report';
export const PROCESS_ACTIVE_TAMPER_REPORT =
  '[reports] process active tamper report';
export const INSERT_ACTIVE_TAMPER_REPORT =
  '[reports] insert active tamper report';
export const REPORTS_ERROR = '[reports] Reports error';

export const LOAD_AUDIT_LOGS_REPORT = '[reports] load audit logs report';
export const PROCESS_AUDIT_LOGS_REPORT = '[reports] process audit logs report';
export const INSERT_AUDIT_LOGS_REPORT = '[reports] insert audit logs report';
export const APPEND_AUDIT_LOGS_REPORT = '[reports] append to audit logs report';
export const PROCESS_APPEND_AUDIT_LOGS_REPORT = '[reports] process append audit logs report';

export const APPEND_ACTIVE_TAMPER_REPORT = '[reports] append to active tamper report';
export const PROCESS_APPEND_ACTIVE_TAMPER_REPORT = '[reports] process append active tamper report';

export const APPEND_MISSING_DEVICES_REPORT = '[reports] append to missing devices report';
export const PROCESS_APPEND_MISSING_DEVICES_REPORT = '[reports] process append missing devices report';

export const APPEND_LOWBATT_REPORT = '[reports] append to low battery devices report';
export const PROCESS_APPEND_LOWBATT_REPORT = '[reports] process append low battery devices report';

export const APPEND_DORMANT_DEVICES_REPORT = '[reports] append to dormant devices report';
export const PROCESS_APPEND_DORMANT_DEVICES_REPORT = '[reports] process append dormant devices report';

export const loadLowBattReport = () => ({
  type: LOAD_LOW_BATT_REPORT,
});
export const processLowBattReport = (payload) => ({
  type: PROCESS_LOW_BATT_REPORT,
  payload,
});
export const insertLowBattReport = (payload) => ({
  type: INSERT_LOW_BATT_REPORT,
  payload,
});
export const appendLowBattReport = (payload) => ({
  type: APPEND_LOWBATT_REPORT,
  payload,
});
export const processAppendLowBattReport = (payload) => ({
  type: PROCESS_APPEND_LOWBATT_REPORT,
  payload,
});
export const loadDormantDevicesReport = () => ({
  type: LOAD_DORMANT_DEVICES_REPORT,
});
export const processDormantDevicesReport = (payload) => ({
  type: PROCESS_DORMANT_DEVICES_REPORT,
  payload,
});
export const insertDormantDevicesReport = (payload) => ({
  type: INSERT_DORMANT_DEVICES_REPORT,
  payload,
});
export const appendDormantDevicesReport = (payload) => ({
  type: APPEND_DORMANT_DEVICES_REPORT,
  payload,
});
export const processAppendDormantDevicesReport = (payload) => ({
  type: PROCESS_APPEND_DORMANT_DEVICES_REPORT,
  payload,
});

export const loadMissingDevicesReport = () => ({
  type: LOAD_MISSING_DEVICES_REPORT,
});
export const processMissingDevicesReport = (payload) => ({
  type: PROCESS_MISSING_DEVICES_REPORT,
  payload,
});
export const insertMissingDevicesReport = (payload) => ({
  type: INSERT_MISSING_DEVICES_REPORT,
  payload,
});
export const appendMissingDevicesReport = (payload) => ({
  type: APPEND_MISSING_DEVICES_REPORT,
  payload,
});
export const processAppendMissingDevicesReport = (payload) => ({
  type: PROCESS_APPEND_MISSING_DEVICES_REPORT,
  payload,
});

export const loadActivetamperreport = () => ({
  type: LOAD_ACTIVE_TAMPER_REPORT,
});
export const processActivetamperreport = (payload) => ({
  type: PROCESS_ACTIVE_TAMPER_REPORT,
  payload,
});
export const insertActivetamperreport = (payload) => ({
  type: INSERT_ACTIVE_TAMPER_REPORT,
  payload,
});
export const appendActiveTamperReport = (payload) => ({
  type: APPEND_ACTIVE_TAMPER_REPORT,
  payload,
});
export const processAppendActiveTamperReport = (payload) => ({
  type: PROCESS_APPEND_ACTIVE_TAMPER_REPORT,
  payload,
});
export const reportsError = (payload) => ({
  type: REPORTS_ERROR,
  payload,
});

export const loadAuditLogsReport = () => ({
  type: LOAD_AUDIT_LOGS_REPORT,
});
export const processAuditLogsReport = (payload) => ({
  type: PROCESS_AUDIT_LOGS_REPORT,
  payload,
});
export const insertAuditLogsReport = (payload) => ({
  type: INSERT_AUDIT_LOGS_REPORT,
  payload,
});
export const appendAuditLogsReport = (payload) => ({
  type: APPEND_AUDIT_LOGS_REPORT,
  payload,
});
export const processAppendAuditLogsReport = (payload) => ({
  type: PROCESS_APPEND_AUDIT_LOGS_REPORT,
  payload,
});
